































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import AsesmenKeperawatanGadarStore from "@/store/modules/AsesmenKeperawatanGadarStore";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import { storePasien } from "@/store/modules/pasien";
import { storeCatatanEdukasi } from "@/store/modules/catatanedukasi";
import AsesmenAwalGadarIndex from "@/components/AsesmenAwalGadar/Index.vue";
import AsesmenAwalGadarIntegrated from "@/components/AsesmenAwalGadar/Integrated.vue";
import CardAsesmenRisikoJatuh from "@/components/pemeriksaan/assesmen/CardAsesmenRisikoJatuh.vue";
import CardCatatanEdukasi from "@/components/pemeriksaan/assesmen/catatanedukasi/CardCatatanEdukasi.vue";
import SoapPage from "@/components/soap/SoapPage.vue";
import CpptRanapPage from "@/components/soap/CpptRanapPage.vue";
import TandaVitalEws from "@/components/TandaVitalEws.vue";
import AsesmenRisikoJatuhPage from "@/components/pemeriksaan/assesmen/AsesmenRisikoJatuhPage.vue";
import CatatanPemberianObatPage from "@/pages/pemeriksaan_ranap/CatatanPemberianObatPage.vue";
import AskepRanapPage from "@/components/pemeriksaan/AskepRanapPage.vue";
import TransferInternalPage from "@/components/pti/TransferInternalPage.vue";
import LaporanOperasiPage from "@/pages/pemeriksaan_ranap/LaporanOperasiPage.vue";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import ScreeningTrombolisisPage from "@/components/pemeriksaan/assesmen/ScreeningTrombolisisPage.vue";
import MonitoringKritisIgdList from "@/components/pemeriksaan/tabs/rekam-medis/MonitoringKritisIgd/MonitoringKritisIgdList.vue";
import MonitoringTrombolisisList from "@/components/pemeriksaan/tabs/rekam-medis/MonitoringTrombolisis/MonitoringTrombolisisList.vue";
import Partograf from "@/components/pemeriksaan/Partograf.vue";
import CardNihssAssessment from "@/components/pemeriksaan/tabs/rekam-medis/CardNihssAssessment.vue";
import IcuHcuPage from "@/components/pemeriksaan/icu-hcu/IcuHcuPage.vue";
import PenggunaanAlatReuseRanapTab from "@/components/pemeriksaan/alat-reuse/PenggunaanAlatReuseRanapTab.vue";
import LembarObservasiKebidananPage from "@/components/pemeriksaan/tabs/rekam-medis/lembar-observasi-kebidanan/LembarObservasiKebidananPage.vue";
import BundlePpiPage from "@/components/pemeriksaan/bundle-ppi/BundlePpiPage.vue";
import SkriningBunuhDiriPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningBunuhDiriPage.vue";
import MppPage from "@/pages/pemeriksaan_ranap/MppPage.vue";
import { MPP_TAB } from "@/utils/ralanFormRegistry";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";

@Component({
  components: {
    AsesmenAwalGadarIndex,
    AsesmenAwalGadarIntegrated,
    CardAsesmenRisikoJatuh,
    CardCatatanEdukasi,
    SoapPage,
    TandaVitalEws,
    AsesmenRisikoJatuhPage,
    CpptRanapPage,
    CatatanPemberianObatPage,
    AskepRanapPage,
    TransferInternalPage,
    LaporanOperasiPage,
    ScreeningTrombolisisPage,
    MonitoringKritisIgdList,
    MonitoringTrombolisisList,
    Partograf,
    CardNihssAssessment,
    IcuHcuPage,
    PenggunaanAlatReuseRanapTab,
    LembarObservasiKebidananPage,
    BundlePpiPage,
    SkriningBunuhDiriPage,
    MppPage
  }
})
export default class RekamMedisIgd extends Vue {
  @Prop() register!: number;
  @Prop({ default: null }) deepLink!: any;

  tab = "tab-asesmen-awal-gadar";

  get tabs() {
    return [
      {
        name: "Asesmen Awal <br />Gawat Darurat",
        href: "#tab-asesmen-awal-gadar",
        elemId: "tab-asesmen-awal-gadar",
        component: "AsesmenAwalGadarIntegrated",
        bind: { deepLink: this.deepLink },
        onClick: () => {
          return this.loadAsesmenAwalGadar();
        }
      },
      {
        name: "Asuhan<br/>Keperawatan",
        href: "#tab-askep-gadar",
        elemId: "tab-askep-gadar",
        component: "AskepRanapPage",
        onClick: () => {
          return true;
        }
      },
      {
        name: "Screening<br/>Trombolisis",
        href: "#tab-trombolisis",
        elemId: "tab-trombolisis",
        component: "ScreeningTrombolisisPage",
        onClick: () => {
          return true;
        }
      },
      {
        name: "Penilaian<br/>NIHSS",
        href: "#tab-nihss",
        elemId: "tab-nihss",
        component: "CardNihssAssessment",
        onClick: () => {
          return true;
        }
      },
      {
        name: "Skrining Risiko<br/>Bunuh Diri",
        href: "#tab-skrining-bunuh-diri",
        elemId: "tab-skrining-bunuh-diri",
        component: "SkriningBunuhDiriPage",
        bind: { encounterType: "igd" },
        onClick: () => {
          return true;
        }
      },
      {
        name: "CPPT",
        href: "#tab-cppt",
        elemId: "tab-cppt",
        component: "CpptRanapPage",
        bind: { showBundelSuket: true },
        onClick: () => {
          return true;
        }
      },
      {
        name: "MPP",
        href: `#${MPP_TAB}`,
        elemId: MPP_TAB,
        component: "MppPage",
        onClick: () => {
          return true;
        }
      },
      // {
      //   name: "SPRI",
      //   href: "#tab-spri",
      //   elemId: "tab-spri",
      //   component: "SpriTabPage",
      //   props: {
      //     isActive: this.tab === "tab-spri"
      //   },
      //   onClick: () => {
      //     return true;
      //   }
      // },
      // {
      //   name: "Monitor TTV",
      //   href: "#tab-tanda-vital",
      //   elemId: "tab-tanda-vital",
      //   component: "TandaVitalEws",
      //   onClick: () => {
      //     return true;
      //   }
      // },
      // {
      //   name: "Asesmen Risiko Jatuh",
      //   href: "#tab-asesmen-risjat",
      //   elemId: "tab-asesmen-risjat",
      //   component: "AsesmenRisikoJatuhPage",
      //   onClick: () => {
      //     return true;
      //   }
      // }
      {
        name: "Laporan Operasi",
        href: "#tab-laporan-operasi",
        elemId: "tab-laporan-operasi",
        component: "LaporanOperasiPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-laporan-operasi"
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Catatan Pemberian Obat",
        href: "#tab-catatan-pemberian-obat",
        elemId: "tab-catatan-pemberian-obat",
        component: "CatatanPemberianObatPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-catatan-pemberian-obat"
        },
        onClick: () => {
          // return true;
          this.getByRegister();
        }
      },
      {
        name: "Catatan Edukasi",
        href: "#tab-catatan-edukasi",
        elemId: "tab-catatan-edukasi",
        component: "CardCatatanEdukasi",
        visibility: true,
        onClick: () => {
          storeCatatanEdukasi.actCatatanEdukasi(this.register);
          return true;
        }
      },
      {
        name: "Transfer Internal",
        href: "#tab-transfer-internal",
        elemId: "tab-transfer-internal",
        component: "TransferInternalPage",
        visibility: true,
        props: {
          isActive: this.tab === "tab-transfer-internal",
          reload: true
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitoring <br />Pasien IGD",
        href: "#tab-monitoring-kritis",
        elemId: "tab-monitoring-kritis",
        component: "MonitoringKritisIgdList",
        visibility: true,
        onClick: () => {
          return true;
        }
      },
      {
        name: "Monitoring <br />Trombolisis",
        href: "#tab-monitoring-trombolisis",
        elemId: "tab-monitoring-trombolisis",
        component: "MonitoringTrombolisisList",
        visibility: true,
        onClick: () => {
          return true;
        }
      },
      {
        name: "Kriteria Masuk/<br />Keluar IRI",
        href: "#tab-kriteria-iri",
        elemId: "tab-kriteria-iri",
        component: "IcuHcuPage",
        visibility: true,
        //  monitoring 24 jam tetap milik Ranap — IGD hanya menilai kriteria masuk/keluar
        bind: { showMonitoring: false },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Partograf",
        href: "#tab-partograf",
        elemId: "tab-partograf",
        component: "Partograf",
        visibility: true,
        onClick: () => {
          return true;
        }
      },
      {
        name: "Observasi<br />Kebidanan",
        href: "#tab-observasi-kebidanan",
        elemId: "tab-observasi-kebidanan",
        component: "LembarObservasiKebidananPage",
        visibility: true,
        bind: {
          registerId: this.register,
          pasienRm: this.rm != null ? String(this.rm) : "",
          unitId: this.stateuser.unit_id,
          showTtvImport: false
        },
        onClick: () => {
          return true;
        }
      },
      {
        name: "Bundle PPI",
        href: "#tab-bundle-ppi",
        elemId: "tab-bundle-ppi",
        component: "BundlePpiPage",
        visibility: true,
        onClick: () => {
          return true;
        }
      },
      {
        name: "Penggunaan<br />Alat Reuse",
        href: "#tab-penggunaan-alat-reuse",
        elemId: "tab-penggunaan-alat-reuse",
        component: "PenggunaanAlatReuseRanapTab",
        visibility: true,
        onClick: () => {
          return true;
        }
      }
    ];
  }

  //  alias non-shadow: di template, `tab` sudah dipakai alias v-for
  get currentTab() {
    return this.tab;
  }

  @Watch("deepLink", { immediate: true })
  onDeepLink(payload) {
    if (!payload || payload.topTab !== "tab-assesmen" || !payload.elemId) {
      return;
    }
    this.tab = payload.elemId;
    const target = this.tabs.find(t => t.elemId === payload.elemId);
    if (target && typeof target.onClick === "function") {
      target.onClick();
    }
  }

  @Watch("tab")
  onTabChange() {
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  onNavigateTab(elemId: string) {
    if (elemId) {
      this.tab = elemId;
    }
  }

  get stateuser() {
    return userModule.user;
  }

  get rm() {
    return storePasien.identitasPasien?.rm;
  }

  get param() {
    return {
      unit_id: this.stateuser.unit_id,
      reg: this.register,
      profesi: this.stateuser.profesi,
      id: this.stateuser.id
    };
  }

  loadAsesmenAwalGadar() {
    AsesmenKeperawatanGadarStore.getByRegister(this.register);
    AsesmenMedisIgdStore.getByRegister(this.register);
    SurveyPrimerIgdStore.getByRegister(this.register);
  }

  async getByRegister() {
    await CatatanPemberianObatStore.getByRegister(this.register).then(() => {});
  }
}
